import React from "react";
import { Chip, Stack, Typography } from "@mui/material";

interface RemarksChipsProps {
  remarks: string | null | undefined;
  size?: "small" | "medium";
}

/** Splits the model's semicolon-joined `remarks` string into individual warning chips. */
const RemarksChips: React.FC<RemarksChipsProps> = ({ remarks, size = "small" }) => {
  const items = (remarks || "")
    .split(";")
    .map((r) => r.trim())
    .filter(Boolean);

  if (items.length === 0 || (items.length === 1 && items[0].toLowerCase() === "no major issue detected")) {
    return (
      <Typography variant="body2" color="text.secondary">
        No major issue detected
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
      {items.map((item, idx) => (
        <Chip key={`${item}-${idx}`} size={size} color="warning" variant="outlined" label={item} />
      ))}
    </Stack>
  );
};

export default RemarksChips;
